export default __webpack_public_path__ + "static/media/ibutton.f9424ccb.svg";